import { Collapse } from "antd";
import { SectionButton } from "common/button";
import styled from "styled-components";

export const CollapsedSearchResult = styled(Collapse)`
  background-color: transparent;
  margin-top: 24px;

  &.ant-collapse > .ant-collapse-item > .ant-collapse-header {
    padding: 8px 0px;
    text-align: left;
    color: #1070b6;
    font-weight: bold;
    font-size: 15px;
    &[aria-expanded="true"] .ant-collapse-extra > .ant-row > .ant-col > .book-all {
        background-color: #fdd440;
      }
    &[aria-expanded="true"] .ant-collapse-extra > .ant-row > .ant-col > button.show span:before {
      content: "HIDE ";
    }
    &[aria-expanded="false"] .ant-collapse-extra > .ant-row > .ant-col > button.show span:before {
      content: "SHOW ";
    }
  }
  }

  &.ant-collapse-borderless
    > .ant-collapse-item
    > .ant-collapse-content
    > .ant-collapse-content-box {
    padding: 0px 0px 16px;
  }

  &.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content {
    overflow: visible;
  }

  &.ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header
    .ant-collapse-arrow {
    position: relative;
    left: 0px;
    color: #1070b6;
    font-size: 16px;
    transform: scaleX(1.5);
    transition: transform 0.24s;
    margin-right: 12px;
    top: 50%;
    padding: 0px;
  }

  &.ant-collapse
    > .ant-collapse-item.ant-collapse-item-active
    > .ant-collapse-header
    .ant-collapse-arrow {
    transform: scaleY(1.5) rotate(90deg);
  }
  &.ant-collapse-borderless > .ant-collapse-item {
    border-top: 2px solid #1070b6;
  }
`;

export const StyledSectionButton = styled(SectionButton)`
  font-size: 14px;
  padding: 0;
  background-color: rgb(211, 232, 255);
  &.show:active,
  &.show:focus {
    background-color: rgb(211, 232, 255);
  }
`;
